import 'bootstrap/dist/css/bootstrap.min.css';
import './public/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './public/css/main.css';
import { Route, Routes, useLocation } from "react-router-dom";
import MainScreen from "./Screens/MainScreen";
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';

import { useCookies } from 'react-cookie';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser, loadingChange, loadingLogoutChange } from './redux/slices/AuthSlice';
import Auth from './Screens/Auth/Auth';
import AllProducts from './Screens/AllProducts';
import CartScreen from './Screens/CartScreen';
import MainCategoryProducts from './Screens/MainCategoryProducts';
import CategoryProducts from './Screens/CategoryProducts';
import ProductSelect from './Screens/ProductSelect';
import Message from './Components/Message';
import Loading from './Screens/Loading';
import NotFound from './Screens/NotFound';
import Payment from './Screens/Payment';
import CheckAuth from './Components/CheckAuth';
import axios from 'axios';
import { setSetting } from './redux/slices/SettingSlice';
import { URL } from './config';
import Page from './Screens/Page';
import Announcement from './Screens/Announcement';
import Profile from './Screens/Profile';
import { useFetchWithToken } from './redux/hooks/useFetchWithToken';
import Orders from './Screens/Orders';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
 const dispatch = useDispatch();
 const {data,isLoading,error}=useFetchWithToken('api/profile')

 useEffect(()=>{
  if(data){
    console.log('sadasf',data.data);
    
    dispatch(getCurrentUser({user:data.data,token:cookies.token}));
   }
 },[data])
 useEffect(()=>{
  dispatch(loadingChange());
  axios.get(`${URL}/api/setting`)
  .then(function (response) {
    console.log(response.data);
    if(response.data.success){
      console.log('response.data.data',response.data.data);
      
      dispatch(setSetting(response.data.data));
  
    }

    dispatch(loadingChange());
  })
  .catch(function (error) {
    console.log('error');
    dispatch(loadingChange());
  });
 },[])
 useEffect(() => {
  window.scrollTo(0, 0);
}, [pathname]);
if(isLoading)return <Loading/>
 return(
  <div>
   
   <>
       {pathname!=='/payment'&& <Navbar />}
      <div style={{minHeight:'100vh'}}>
      {children}
      </div> 
      
      {pathname!=='/payment'&& <Footer />}
      </>
  </div>
 );
    };
function App() {
  
  const {isLogoutLoading}=useSelector((state)=>state.AuthReducer);
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const dispatch = useDispatch();

  useEffect(()=>{
  
    if(cookies.user){
      console.log('es.use',cookies.user);
      
      dispatch(getCurrentUser({user:cookies.user,token:cookies.token}));
    }
  },[])

   
  
  return (
    <>
    
    
    {isLogoutLoading?(
      <Loading/>
    ):(
       <>
      <Message/>
      <div>
      <Layout>
  <Routes>
    <Route path="/" element={<MainScreen />} />
    <Route path="/profile" element={<CheckAuth><Profile /></CheckAuth>} />
    <Route path="/orders" element={<CheckAuth><Orders /></CheckAuth>} />
    <Route path="/page/:term/:id" element={<Page />} />
    <Route path="/all_products" element={<AllProducts />} />
    <Route path="/announcement/:id/:title" element={<Announcement />} />
    <Route path="/product/:id" element={<ProductSelect />} />
    <Route path="/main_category/:MainCategoryId/:MainCategoryName" element={<MainCategoryProducts />} />
    <Route path="/category/:MainCategoryId/:MainCategoryName/:CategoryId/:CategoryName" element={<CategoryProducts />} />
    <Route path="/cart" element={<CartScreen />} />
    <Route path="/payment" element={<CheckAuth><Payment /></CheckAuth>} />
    <Route path="/*" element={<NotFound />} />
  </Routes>
</Layout>

     
      </div>
      </>
    )}
   
   
    </>
   
  );
}

export default App;
